<div class="confirm-modal-overlay" *ngIf="visible" (click)="onBackdropClick()">
  <div class="confirm-modal" (click)="$event.stopPropagation()">
    <button type="button" class="close-icon" aria-label="Close" (click)="onCancel()">&times;</button>
    <div class="confirm-badge" [class.danger]="danger">{{ danger ? 'Delete' : 'Confirm' }}</div>
    <h3>{{ title }}</h3>
    <p>{{ message }}</p>
    <div class="confirm-actions">
      <button type="button" class="cancel-btn" [disabled]="isLoading" (click)="onCancel()">{{ cancelLabel }}</button>
      <button type="button" class="confirm-btn" [class.danger]="danger" [disabled]="isLoading" (click)="onConfirm()">
        {{ isLoading ? 'Processing...' : confirmLabel }}
      </button>
    </div>
  </div>
</div>
